export default __webpack_public_path__ + "static/media/grafema_minha-casa_04.d0d66afb.jpg";